import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'wdx-tab-actions',
    templateUrl: './wdx-tab-actions.component.html',
    styleUrls: ['./wdx-tab-actions.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class WdxTabActionsComponent {}
